/* @flow */
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import * as React from 'react';
import QuickPromotion from 'entities/QuickPromotion';
import CurrentUser from 'auth/CurrentUser';
import QuickPromotionModal from 'components/QuickPromotionModal.jsx';
import LoadingModal from 'components/LoadingModal.jsx';
import invariant from 'invariant';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { ButtonActionTypes, TriggerTypes, ResponseTypes } from 'constants/QuickPromotionConstants';
import { mountModal } from 'lib/modal';

type State = {
  promotions: Array<QuickPromotion>,
};

class QuickPromotionAppOpenedModals extends React.Component<{}, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static getStores() {
    return [CurrentUser];
  }

  static calculateState(): State {
    return {
      promotions: CurrentUser.getQuickPromotionsForTrigger(TriggerTypes.APP_OPENED),
    };
  }

  componentDidMount() {
    this.checkForPrompts();
  }

  componentDidUpdate() {
    this.checkForPrompts();
  }

  shown = false;

  handleConfirm = (promotion: QuickPromotion, data: ?Object) => {
    if (
      promotion.getPrimaryAction().getActionType() === ButtonActionTypes.LINK ||
      promotion.getPrimaryAction().getActionType() === ButtonActionTypes.DEEPLINK
    ) {
      mountModal(<LoadingModal />, this);
    }
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION, data);
  };
  handleCancel = (promotion: QuickPromotion) => {
    const secondaryAction = promotion.getSecondaryAction();
    invariant(secondaryAction, 'Cannot call cancel without a secondary action');
    if (
      secondaryAction.getActionType() === ButtonActionTypes.LINK ||
      secondaryAction.getActionType() === ButtonActionTypes.DEEPLINK
    ) {
      mountModal(<LoadingModal />, this);
    }
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
  };
  checkForPrompts() {
    const { promotions } = this.state;

    if (!this.shown) {
      const promotion = promotions.find(p => p.isShowable());
      if (promotion) {
        this.shown = true;

        mountModal(
          <QuickPromotionModal
            onConfirm={this.handleConfirm}
            onCancel={this.handleCancel}
            promotion={promotion}
            triggeredContext={'quick_promotion:' + promotion.getPromotion()}
            onRequestHide={() => {} /* Flow can't deal with injected props */}
          />,
          this
        );
      }
    }
  }

  render() {
    return null;
  }
}

export default Container.create(QuickPromotionAppOpenedModals, { pure: false });
